export default __webpack_public_path__ + "img/map-marker-constituent_sites-active.f7dfd507.png";